"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var EmailMediaAttachmentCountsRecord = (0, _immutable.Record)({
  numberOfVideos: 0,
  numberOfImages: 0,
  numberOfAttachments: 0,
  numberOfLinks: 0
}, 'EmailMediaAttachmentCountsRecord');

EmailMediaAttachmentCountsRecord.fromRteResults = function (rteResults) {
  return new EmailMediaAttachmentCountsRecord({
    numberOfImages: rteResults.numberOfImages(),
    numberOfVideos: rteResults.numberOfVideos(),
    numberOfLinks: rteResults.numberOfLinks()
  });
};

var _default = EmailMediaAttachmentCountsRecord;
exports.default = _default;
module.exports = exports.default;